import { z } from 'zod';

export const complianceSchema = z
  .object({
    comment: 
      z
        .string()
        .trim()
        .max(200, { message: 'Too long. Maximum is 200 characters' })
        .optional(),
    //only for validation
    fileIds: z
      .array(z.string())
      .max(10, 'Maximum is 10 files')
      .optional(),
  })
  .refine(
    (value) => {
      const hasComment = typeof value.comment === 'string' && value.comment.length > 0;
      //const hasFiles = Array.isArray(value.fileIds) && value.fileIds.length > 0; TODO: in case files are required later
      return hasComment //|| hasFiles;
    },
    { message: 'Field is required', path: ['comment'] },
  );

export type ComplianceSchema = z.infer<typeof complianceSchema>;
